import {
  BriefcaseMedical,
  CalendarCheck,
  CalendarClock,
  CalendarHeart,
  CalendarRange,
  ClipboardList,
  Database,
  LayoutDashboard,
  Search,
  ShieldCheck,
  Stethoscope,
  UserRound,
  type LucideIcon,
} from "lucide-react";
import type { Portal } from "@/features/auth/types";
import { PORTAL_HOME, ROUTES } from "./routes";

export type NavItem = { to: string; labelKey: string; icon: LucideIcon; end?: boolean; permission?: string };

/** Per-portal identity and navigation. Items with a permission are hidden from users without it. */
export const PORTAL_CONFIG: Record<Portal, { labelKey: string; icon: LucideIcon; nav: NavItem[] }> = {
  PATIENT: {
    labelKey: "portal.PATIENT",
    icon: CalendarHeart,
    nav: [
      { to: PORTAL_HOME.PATIENT, labelKey: "nav.home", icon: LayoutDashboard, end: true },
      { to: ROUTES.PATIENT_FIND_DOCTORS, labelKey: "nav.findDoctor", icon: Search },
      { to: ROUTES.PATIENT_APPOINTMENTS, labelKey: "nav.myAppointments", icon: CalendarHeart },
    ],
  },
  DOCTOR: {
    labelKey: "portal.DOCTOR",
    icon: Stethoscope,
    nav: [
      { to: PORTAL_HOME.DOCTOR, labelKey: "nav.home", icon: LayoutDashboard, end: true },
      { to: ROUTES.DOCTOR_APPOINTMENTS, labelKey: "nav.appointments", icon: CalendarClock, permission: "appointments:read:doctor" },
      { to: ROUTES.DOCTOR_SCHEDULE, labelKey: "nav.schedule", icon: CalendarRange, permission: "schedules:manage:own" },
      { to: ROUTES.DOCTOR_PROFILE, labelKey: "nav.doctorProfile", icon: BriefcaseMedical, permission: "doctor-profile:update:own" },
    ],
  },
  ADMIN: {
    labelKey: "portal.ADMIN",
    icon: ShieldCheck,
    nav: [
      { to: PORTAL_HOME.ADMIN, labelKey: "nav.home", icon: LayoutDashboard, end: true },
      { to: ROUTES.ADMIN_APPOINTMENTS, labelKey: "nav.appointments", icon: CalendarCheck, permission: "appointments:read" },
      { to: ROUTES.ADMIN_DOCTORS, labelKey: "nav.doctors", icon: Stethoscope, permission: "doctors:read" },
      { to: ROUTES.ADMIN_MASTER_DATA, labelKey: "nav.masterData", icon: Database, permission: "master-data:read" },
    ],
  },
  EXECUTIVE: {
    labelKey: "portal.EXECUTIVE",
    icon: ClipboardList,
    nav: [
      { to: PORTAL_HOME.EXECUTIVE, labelKey: "nav.home", icon: LayoutDashboard, end: true },
      { to: ROUTES.EXECUTIVE_APPOINTMENTS, labelKey: "nav.appointments", icon: CalendarCheck, permission: "appointments:read" },
    ],
  },
};

export const ACCOUNT_NAV: NavItem[] = [
  { to: ROUTES.ACCOUNT_PROFILE, labelKey: "nav.profile", icon: UserRound },
  { to: ROUTES.ACCOUNT_SECURITY, labelKey: "nav.security", icon: ShieldCheck },
];
